import React from "react";

import * as styles from "../styles/NumberPicker.module.css";

export interface NumberPickerProps {
  increment: () => void;
  decrement: () => void;
  value: number;
}

const NumberPicker = (props: NumberPickerProps) => {
  return (
    <div
      style={{
        margin: 10,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <button className={"button " + styles.btn} onClick={props.decrement}>
        -
      </button>
      <input
        type="number"
        step={1}
        min={1}
        className={styles.input}
        value={props.value}
        readOnly={true}
      />
      <button className={"button " + styles.btn} onClick={props.increment}>
        +
      </button>
    </div>
  );
};

export default NumberPicker;
